import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import PersonOutlinedIcon from "@material-ui/icons/PersonOutlined";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import WorkOutlinedIcon from "@material-ui/icons/WorkOutlined";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

const useStyles = makeStyles((theme) => ({
	jobRow: {
		background: "#011C33",
		borderRadius: "12px",
		marginBottom: "12px",
		overflow: "hidden",
		transition: "background 0.2s",
		"&:hover": {
			background: "#00192f",
		},
	},
	jobRowHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		padding: "20px 24px",
		cursor: "pointer",
		[theme.breakpoints.down("sm")]: {
			padding: "14px 16px",
		},
	},
	jobInfo: {
		flex: 1,
	},
	jobTitle: {
		fontSize: "18px",
		fontWeight: 700,
		color: "#ffffff",
		marginBottom: "6px",
		[theme.breakpoints.down("sm")]: {
			fontSize: "15px",
		},
	},
	tagsRow: {
		display: "flex",
		alignItems: "center",
		gap: "20px",
		flexWrap: "wrap",
		[theme.breakpoints.down("sm")]: {
			gap: "10px",
		},
	},
	tag: {
		display: "flex",
		alignItems: "center",
		gap: "4px",
		fontSize: "13px",
		color: "rgba(255, 255, 255, 0.65)",
		"& svg": {
			fontSize: "15px",
		},
	},
	jobDetails: {
		padding: "0 24px 24px",
		borderTop: "1px solid rgba(255, 255, 255, 0.1)",
		[theme.breakpoints.down("sm")]: {
			padding: "0 16px 16px",
		},
	},
	jobDetailsContent: {
		color: "#fff",
		fontSize: "15px",
		lineHeight: 1.7,
		paddingTop: "20px",
		"& *": {
			color: "#fff !important",
		},
		"& ul": {
			paddingLeft: "20px",
		},
		"& li": {
			marginBottom: "6px",
		},
	},
	headerArrowBtn: {
		width: 40,
		height: 40,
		minWidth: 40,
		borderRadius: "50%",
		border: "1px solid rgba(255, 255, 255, 0.35)",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: "#ffffff",
		flexShrink: 0,
		marginLeft: "20px",
		background: "transparent",
		cursor: "pointer",
		padding: 0,
		transition: "background 0.2s, border-color 0.2s",
		"& svg": {
			transition: "transform 0.3s ease",
		},
		"&:hover": {
			background: "rgba(255, 255, 255, 0.2)",
			borderColor: "rgba(255, 255, 255, 0.8)",
		},
		"& svg": {
			fontSize: "18px",
			color: "#ffffff",
		},
	},
	headerApplyBtn: {
		borderRadius: "50px",
		padding: "8px 22px",
		fontWeight: 600,
		fontSize: "14px",
		textTransform: "none",
		borderColor: "rgba(255,255,255,0.6)",
		color: "#ffffff",
		flexShrink: 0,
		marginLeft: "20px",
		textDecoration: "none",
		"&:hover": {
			borderColor: "#ffffff",
			color: "#ffffff",
			background: "rgba(255,255,255,0.1)",
		},
	},
	bottomApplyBtn: {
		marginTop: "20px",
		borderRadius: "50px",
		padding: "8px 22px",
		fontWeight: 600,
		fontSize: "14px",
		textTransform: "none",
		borderColor: "rgba(255,255,255,0.6)",
		color: "#ffffff",
		textDecoration: "none",
		"&:hover": {
			borderColor: "#ffffff",
			color: "#ffffff",
			background: "rgba(255,255,255,0.1)",
		},
	},
}));

function FeaturedOpening({ open, each, setChange }) {
	const {
		position,
		location,
		applyLink,
		content,
		level = "Mid-Senior Level",
		jobType = "Full Time",
	} = each;

	const classes = useStyles();

	return (
		<Box className={classes.jobRow}>
			<Box className={classes.jobRowHeader} onClick={setChange}>
				<div className={classes.jobInfo}>
					<Typography className={classes.jobTitle}>{position}</Typography>
					<div className={classes.tagsRow}>
						<span className={classes.tag}>
							<PersonOutlinedIcon />
							{level}
						</span>
						<span className={classes.tag}>
							<RoomOutlinedIcon />
							{location}
						</span>
						<span className={classes.tag}>
							<WorkOutlinedIcon />
							{jobType}
						</span>
					</div>
				</div>
					<button
						aria-label="Open job details"
						className={classes.headerArrowBtn}
						onClick={(e) => {
							e.stopPropagation();
							setChange();
						}}
						type="button"
					>
						<KeyboardArrowDownIcon style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }} />
					</button>
			</Box>
			<Collapse in={open} timeout="auto" unmountOnExit>
				<Box className={classes.jobDetails}>
					<div className={classes.jobDetailsContent}>{content}</div>
					{applyLink && (
						<Button
							className={classes.bottomApplyBtn}
							component="a"
							endIcon={<ArrowForwardIcon />}
							href={applyLink}
							rel="nofollow"
							target="_blank"
							variant="outlined"
						>
							Apply
						</Button>
					)}
				</Box>
			</Collapse>
		</Box>
	);
}

FeaturedOpening.propTypes = {
	open: PropTypes.bool,
	each: PropTypes.object,
	setChange: PropTypes.func,
};

FeaturedOpening.defaultProps = {
	open: false,
};

export default FeaturedOpening;
